import type * as React from 'react';

function SvgInstagramFlat(props: React.SVGProps<SVGSVGElement>) {
  return (
    <svg height="50" viewBox="0 0 50 50" width="50" {...props}>
      <g>
        <path
          clipRule="evenodd"
          d="M18.3335 41.25H32.4358C37.0312 41.25 40.7692 37.4535 40.7692 32.7867V18.4637C40.7692 13.7965 37.0312 10 32.4358 10H18.3335C13.7385 10 10 13.7965 10 18.4637V32.7863C10 37.4535 13.7385 41.25 18.3335 41.25ZM12.5642 18.4637C12.5642 15.2328 15.1523 12.6043 18.3335 12.6043H32.4358C35.6169 12.6043 38.205 15.2328 38.205 18.4637V32.7867C38.205 36.0176 35.6169 38.6461 32.4358 38.6461H18.3335C15.1523 38.6461 12.5642 36.0176 12.5642 32.7867V18.4637ZM17.9487 25.625C17.9487 29.9324 21.3995 33.4375 25.641 33.4375C29.8826 33.4375 33.3333 29.9324 33.3333 25.625C33.3333 21.3168 29.8826 17.8125 25.641 17.8125C21.3995 17.8125 17.9487 21.3168 17.9487 25.625ZM20.513 25.625C20.513 22.7531 22.8133 20.4168 25.641 20.4168C28.4691 20.4168 30.7691 22.7531 30.7691 25.625C30.7691 28.4973 28.4687 30.8332 25.641 30.8332C22.8133 30.8332 20.513 28.4973 20.513 25.625ZM33.8141 19.1145C34.7876 19.1145 35.5768 18.3129 35.5768 17.3242C35.5768 16.3355 34.7876 15.534 33.8141 15.534C32.8406 15.534 32.0514 16.3355 32.0514 17.3242C32.0514 18.3129 32.8406 19.1145 33.8141 19.1145Z"
          fill="currentColor"
          fillRule="evenodd"
        />
      </g>
    </svg>
  );
}

export default SvgInstagramFlat;
